<template>
  <a-card class="mb-5">
    <expert-info-detail-component ref="infoDetailRef"
                                  :expertInfo="expertInfo"
                                  :showState="true"
                                  :showEditPhone="true"
                                  @editPhone="onEditPhone(expertInfo)">
      <template slot="content">
        <div class="zjmp_t3">
          <!-- 正常-->
          <div>入库：{{ expertInfo.addDate | dateFormat }}</div>
          <div>已入库<b>{{ expertInfo.addDate | fromNow  }}</b>天</div>
          <!--   已出库-->
          <template v-if="expertState.STATE.OUT_SUCCESS === expertInfo.state">
            <div>出库：{{ expertInfo.stockOutDate  | dateFormat }}</div>
            <div>原因:{{ expertInfo.stockOutReason }}</div>
          </template>
        </div>
        <extract-num-view :expert-flag-num-info="{attendRate:expertInfo.extras.attendRate,...expertInfo.extras.singleExpertFlagNumVo}" />
        <!-- <div class="zjmp_t5">
          <a-row :gutter="[12,8]">
            <a-col :span="12">
              <a-button @click="record.historyVisible=true"
                        type="primary"
                        block>活动历史记录</a-button>
            </a-col>
            <a-col :span="12">
              <a-button type="primary"
                        @click="record.leaveVisible=true"
                        block>请假记录</a-button>
            </a-col>
          </a-row>
        </div> -->
      </template>
      <a-space slot="action">
        <a-button type="primary"
                  @click="onEditPurchaseItem">
          修改评审品目
        </a-button>
        <a-button type="primary"
                  @click="onEdit">
          修改资料
        </a-button>
      </a-space>
    </expert-info-detail-component>
    <expert-event-history-record @cancel="record.historyVisible=false"
                                 @success="record.historyVisible=false"
                                 :readOnly="true"
                                 :historyVisible="record.historyVisible"
                                 :expertId="expertInfo.id" />
    <expert-ask-for-leave-record @cancel="record.leaveVisible=false"
                                 @success="record.leaveVisible=false"
                                 :readOnly="true"
                                 :leaveVisible="record.leaveVisible"
                                 :expertId="expertInfo.id" />
    <expert-edit ref="expertEditRef"
                 @success="afterSuccess" />
    <EditExpertPurchaseItem ref="editExpertPurchaseItem" />
    <EditMobilePhoneModal ref="editMobilePhone"
                          @success="loadData()"></EditMobilePhoneModal>
  </a-card>
</template>

<script>
import { GetExpertByUserId } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import { ExpertState } from '@/epp/expertmain/expertInfo/utils/ExpertInfoUtil'
import ExpertInfoDetailComponent from './ExpertInfoDetailComponent.vue'
import ExpertEventHistoryRecord from '@/epp/expertmain/expertInfo/common/record/ExpertEventHistoryRecord.vue'
import ExpertAskForLeaveRecord from '@/epp/expertmain/expertInfo/common/record/ExpertAskForLeaveRecord.vue'
import ExtractNumView from '@/epp/expertmain/expertInfo/common/viewitem/ExtractNumView.vue'
import ExpertEdit from '@/epp/expertmain/expertInfo/ExpertEdit.vue'
import EditExpertPurchaseItem from '@/epp/expertmain/expertInfo/common/edititem/EditExpertPurchaseItem.vue'
import EditMobilePhoneModal from '@/views/dashboard/EditMobilePhoneModal.vue'

export default {
  name: 'ExpertLoginView',
  components: {
    ExpertEdit,
    ExpertInfoDetailComponent,
    ExpertEventHistoryRecord,
    ExpertAskForLeaveRecord,
    ExtractNumView,
    EditExpertPurchaseItem,
    EditMobilePhoneModal
  },
  inject: ['reload'],
  data () {
    return {
      expertState: ExpertState,
      user: this.$ls.get('user'),
      expertInfo: {
        extras: {}
      },
      record: {
        historyVisible: false,
        leaveVisible: false,
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    async loadData () {
      let res = await GetExpertByUserId("1")
      this.expertInfo = res.result
    },
    //编辑专家信息
    onEdit () {
      this.$refs.expertEditRef.loadData(this.expertInfo.id)
    },
    // 修改评审品目
    onEditPurchaseItem () {
      this.$refs.editExpertPurchaseItem.initData(this.expertInfo)
    },
    // 修改手机号
    onEditPhone (expertInfoData) {
      this.$refs.editMobilePhone.expertId = expertInfoData.id
      this.$refs.editMobilePhone.editMobilePhoneModal = true
    },
    async afterSuccess () {
      await this.loadData()
      //附件刷新
      this.$refs.infoDetailRef.fileRefresh()
    }
  }
}
</script>

<style scoped lang="less">
.link {
  color: rgb(24, 144, 255);
}

.action button {
  margin-right: 4px;
}

.card {
  margin-bottom: 24px;

  .extras {
    font-weight: 500;
    font-size: 16px;
  }
}

.nav {
  .title {
    text-align: center;
    font-weight: 800;
  }

  .footer {
    text-align: right;
  }
}

.titleCap {
  margin-bottom: 12px;

  .receiveNum {
    padding-left: 16px;
  }

  > span {
    border-right: 1px solid #e6e6e6;
    padding: 0 20px;
  }

  > span:nth-last-child(1) {
    border-right: none;
  }

  > span:nth-child(2) {
    padding-left: 0;
  }
}
</style>
